/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import singleDeviceStyles from '../../styles.module.css';
import { DeviceDetailsContext } from '../../index';
import DeviceOperations from '../../components/DeviceOperations';
import DeviceRemoteSession from './components/DeviceRemoteSession';

const RemoteSession = () => {
  const deviceDetails = useContext(DeviceDetailsContext);
  const [hideOp, setHideOp] = useState(false);

  useEffect(() => {
    // Update the current route's key
    deviceDetails.setCurrentRoute('remote-session');
  }, []);

  const hide = hideOperation => {
    if (hideOperation == 5) {
      setHideOp(true);
    } else {
      setHideOp(false);
    }
  };
  return (
    <div>
      {hideOp ? (
        <Row>
          <Col md={24}>
            <div className={singleDeviceStyles.container}>
              <DeviceRemoteSession
                deviceIdentifier={deviceDetails.deviceIdentifier}
                deviceType={deviceDetails.deviceType}
                hide={hide}
              />
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md={19}>
            <div className={singleDeviceStyles.container}>
              <DeviceRemoteSession
                deviceIdentifier={deviceDetails.deviceIdentifier}
                deviceType={deviceDetails.deviceType}
                hide={hide}
              />
            </div>
          </Col>
          <Col md={5}>
            <DeviceOperations />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default RemoteSession;
